module.exports = __webpack_public_path__ + "media/images/icons/checkbox-79f0c413368e2b67fdf1aac288bd08d1.svg";